import { decodeHexResponse } from '../_common/common.utils';
import LeaveAdjustmentTypes from './LeaveAdjustment.types';

const INITIAL_STATE = {
	employeeLeaveBalance: null,
	createLeaveAdjustment: null,
};

const leaveAdjustmentReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		// GET EMPLOYEE LEAVE BALANCE REDUCER
		case LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_START:
			return { ...state, employeeLeaveBalance: null };
		case LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_SUCCESS:
			return {
				...state,
				employeeLeaveBalance: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_KEY,
				),
			};
		case LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_FAILURE:
			return {
				...state,
				employeeLeaveBalance: { status: 'error', message: action.payload },
			};

		// CREATE LEAVE ADJUSTMENT REDUCER
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_START:
			return { ...state, createLeaveAdjustment: null };
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_SUCCESS:
			return {
				...state,
				createLeaveAdjustment: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_KEY,
				),
			};
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_FAILURE:
			return {
				...state,
				createLeaveAdjustment: { status: 'error', message: action.payload },
			};
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_RESPONSE_RESET:
			return {
				...state,
				createLeaveAdjustment: null,
			};

		default:
			return state;
	}
};

export default leaveAdjustmentReducer;

